export default {
  BUY_WAIT_HEADER: "Your funds are being purchased.",
  BUY_WAIT_SUBHEADING: "Return to this screen shortly to receive an update.",
  BUY_WAIT_BUTTON_HEADING: "Check Status",
};
